export interface Disbursement{
  name?: string;
  id?: string;
}
export interface CommunityDisbursementModel{
  id:number,
  organizationEIN:string,
  accountNickname:string,
  isPrimary:boolean,
}